<template>
  <footer class="footer-section" v-on:click="footerClicked" ref="footer">

    <div class="helpCnt" v-if="contact && contact.enableSupport"
       :class="{offset: helpOffset}">
      <div class="helpBlock" :class="{open: helpOpen}"
        v-on:click="helpOpen = !helpOpen">
        <span class="question"></span>
        <span class="close"></span>
      </div>
      <div class="helpMenu" :class="{open: helpOpen}">
        <h4>{{contact.supportLabel[lang]}}</h4>
        <a :href="item.url" :class="[item.type, {wa: item.isWhatsApp}]"
          v-for="(item, i) in contact.support" :key="`help${i}`"
          v-on:click.prevent="openSupport($event, item)">
          {{item.name}}
        </a>
      </div>
      <div class="helpInfo" :class="{closed: helpInfoClose}"
        v-if="helpInfoOpen && contact.supportInfo[lang]">
        {{contact.supportInfo[lang]}}</div>
    </div>

    <div class="cnt">
      <div class="footer-widgets">
        <div class="links" v-if="links">
          <div class="col-12 col-md-3 footer-widget link-item"
            :style="{width: `${100/links.page.length}%`}"
            v-for="(item, i) in links.page" :key="`pg${i}`">
            <div class="widget-content">
              <h3 class="widget-title title">{{item.title[lang]}}</h3>
              <ul class="lainnya-container">
                <li v-for="(link, i) in item.links" :key="`lnk${i}`">
                  <a :href="link.url[lang]">{{link.name[lang]}}</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3 footer-widget" v-if="address">
          <div class="widget-content">
            <h3 class="widget-title title">{{address.footerAddressLabel[lang]}}</h3>
            <div class="widget-content d-flex notranslate address">
              <div class="location-symbol me-2">
                <font-awesome-icon icon="fa-solid fa-location-dot" class="text-primary" />
              </div>
              {{address.footerAddress[lang]}}
            </div>
            <div class="widget-content d-flex mt-2 notranslate"
              v-for="(item, i) in address.phone" :key="`ph${i}`">
              <div class="location-symbol me-2">
                <font-awesome-icon icon="fa-solid fa-phone" class="text-primary" />
              </div>
              <a :href="`tel:${item.value}`">{{item.value}}</a>
            </div>
            <div class="widget-content d-flex mt-2 notranslate"
              v-for="(item, i) in address.email" :key="`em${i}`">
              <div class="location-symbol me-2">
                <font-awesome-icon icon="fa-solid fa-envelope" class="text-primary" />
              </div>
              <a :href="`mailto:${item.value}`">{{item.value}}</a>
            </div>
          </div>
        </div>
        <div class="col-12 col-md-3 footer-widget" v-if="socmed">
          <div class="widget-content">
            <h3 class="widget-title title">{{socmed.footerSocmedLabel[lang]}}</h3>
            <div class="media-sosial-cta">{{socmed.footerSocmedDesc[lang]}}</div>
            <div class="media-sosial-icon-container mt-2">
              <div class="media-sosial-icon" v-for="(item, i) in socmed.socmed" :key="`sc${i}`">
                <a :href="item.url" target="_blank" :title="item.name">
                  <img v-if="item.media" :src="item.media.imageSm">
                </a>
              </div>
            </div>
            <div class="subscription" v-if="subscription && subscription.enableSubscription">
              <h3 class="widget-title title">{{subscription.subscriptionLabel[lang]}}</h3>
              <button class="btn primary" v-on:click="openSubscribe">
                {{subscription.subscriptionButton[lang]}}
              </button>
            </div>
          </div>
        </div>
      </div>
      <div class="footer-bottom mb-3">
        <div class="footer-bottom-item mb-3 mb-md-0 text-center text-md-start copyright">
          © 2023 - <span v-if="copyright">{{copyright.copyright[lang]}}</span>
        </div>
        <div class="footer-bottom-item">
          <div class="langSelector">
            <button class="langSelectorBtn" :class="lang"
              v-on:click.stop="showLangSelector = !showLangSelector">
              <span v-if="lang === 'en'">English (US)</span>
              <span v-else>Bahasa Indonesia</span>
            </button>
            <div class="langSelectorMenu" v-if="showLangSelector">
              <li v-on:click.stop="selectLang('en')" class="en">English (US)</li>
              <li v-on:click.stop="selectLang('id')" class="id">Bahasa Indonesia</li>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Subscription ref="subscription"/>
  </footer>
</template>

<script>
import Subscription from '@/components/Subscription.vue';

export default {
  components: { Subscription },
  data() {
    return {
      address: null,
      socmed: null,
      links: null,
      copyright: null,

      /**
       * Contact
       *
       */
      contact: null,
      helpOpen: false,
      helpInfoOpen: true,
      helpInfoClose: false,
      helpOffset: false,

      /**
       * Subscription
       *
       */
      subscription: null,

      /**
       * Language
       *
       */
      lang: 'id',
      langCode: 'id-id',
      showLangSelector: false,
    };
  },
  methods: {
    footerClicked() {
      this.showLangSelector = false;
    },
    openSubscribe() {
      this.$refs.subscription.open(this.subscription);
    },
    openSupport(e, item) {
      this.helpOpen = false;
      if (item.url === '#newsletter') {
        this.openSubscribe();
        return;
      }
      if (item.isWhatsApp) window.open(item.url, '_blank').focus();
      else window.location.href = item.url;
    },
    docScrolled() {
      const { body } = document;
      const html = document.documentElement;
      const height = Math.max(body.scrollHeight, body.offsetHeight,
        html.clientHeight, html.scrollHeight, html.offsetHeight);
      const footerHeight = this.$refs.footer.offsetHeight;
      this.helpOffset = window.pageYOffset > height - window.innerHeight - footerHeight;
    },
    selectLang(lang) {
      this.lang = lang;
      this.showLangSelector = false;
      const langCode = lang === 'id' ? 'id-id' : 'en-us';
      const fullPath = this.$route.fullPath.replace(/\/[a-z]+-[a-z]+\/?/, `/${langCode}/`);
      window.location.href = fullPath;
    },
    validateLang(lang) {
      const allowedLang = ['id', 'en'];
      if (!allowedLang.includes(lang)) {
        this.$router.replace({
          query: {
            lang: 'id',
          },
        });
      }
    },
  },
  created() { document.addEventListener('scroll', this.docScrolled); },
  destroyed() { document.removeEventListener('scroll', this.docScrolled); },
  mounted() {
    this.langCode = this.$route.params.lang;
    this.lang = this.langCode === 'id-id' ? 'id' : 'en';

    this.$http.get(this.$config.uri('config/section/address')).then((r) => {
      this.address = r.data.status === 200 ? r.data.data : null;
    });
    this.$http.get(this.$config.uri('config/section/socmed')).then((r) => {
      this.socmed = r.data.status === 200 ? r.data.data : null;
    });
    this.$http.get(this.$config.uri('config/section/subscription')).then((r) => {
      this.subscription = r.data.status === 200 ? r.data.data : null;
    });
    this.$http.get(this.$config.uri('config/section/links')).then((r) => {
      this.links = r.data.status === 200 ? r.data.data : null;
    });
    this.$http.get(this.$config.uri('config/section/copyright')).then((r) => {
      this.copyright = r.data.status === 200 ? r.data.data : null;
    });
    this.$http.get(this.$config.uri('config/section/contact')).then((r) => {
      this.contact = r.data.status === 200 ? r.data.data : null;
      setTimeout(() => {
        this.helpInfoClose = true;
        setTimeout(() => {
          this.helpInfoOpen = false;
        }, 200);
      }, 1600);
    });
  },
};
</script>


<style lang="scss" scoped>
.footer-section{
  position: relative;
  padding-top: 6rem;
  padding-bottom: .5rem !important;
  background-color: #202020;
  color: white;
  font-size: 0.9rem;
  @media (max-width: 1140px) {
    padding-top: 50px;
  }
  h1,h2,h3,h4,h5,h6 {
    color: white;
  }

  .title {
    font-weight: 700;
    font-size: 1.16rem;
    margin-bottom: 1.3rem;
  }

  .widget-section-title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
  }

  ul {
    list-style-type: none;
    // margin-left: 1rem;
    padding: 0;
  }

  .media-sosial-icon-container {
    font-size: 1rem;
    margin-top: .5rem;
  }

  .media-sosial-icon{
    display: inline-block;
    background-color: #008552;
    position: relative;
    text-align: center;
    border-radius: 3px;
    overflow: hidden;
    img{
      height: 32px;
      display: block;
    }
  }
}
.footer-widgets{
  display: flex;
  flex-wrap: wrap;
  .links{
    display: flex;
    flex-wrap: wrap;
    width: calc(100% - 640px);
    @media (max-width: 1460px) {
      width: calc(100% - 560px);
    }
    @media (max-width: 1200px) {
      width: calc(100% - 560px);
    }
    @media (max-width: 1140px) {
      width: 100%;
      padding-bottom: 20px;
    }
    .footer-widget{
      padding-right: 30px;
      @media (max-width: 740px) {
        width: 50% !important;
      }
    }
  }
}
.footer-widget{
  margin-top: 0;
  margin-bottom: 1rem;
  padding-right: 30px;
  box-sizing: border-box;
  width: 320px;
  @media (max-width: 1460px) {
    width: 280px;
  }
  @media (max-width: 1200px) {
    width: 280px;
  }
  @media (max-width: 1140px) {
    width: 50%;
  }
  @media (max-width: 740px) {
    width: 100%;
    padding-right: 0;
  }
  &:last-child{
    padding-right: 0;
  }
  .widget-content{
    margin: 0 0 6px;
    a{
      color: #fff;
      transition: all .3s ease;
      &:hover{
        color: #008552;
      }
    }
    &.address{
      margin: 0 0 10px;
    }
  }
  .media-sosial-icon {
    a{
      transition: 600 all ease-in;
    }

    &:not(:last-child) {
      margin-right: 0.3rem;
    }
    .svg-inline--fa {
      vertical-align: initial;
    }
  }
  .d-flex {
    display: flex;
  }
  .profil-container,
  .organisasi-container,
  .lainnya-container {
    a {
      text-decoration: none;
      &:hover {
        color: #008552;
      }
    }
  }
  .profil-container {
    margin-right: 3rem;
  }
}

ul {
  list-style-type: none;
  li {
    margin-bottom: .3rem;

    a {
      transition: 300ms all;
    }
  }
}

.footer-bottom{
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  border-top: #555 1px solid;
  margin-top: 20px;
  padding-top: 16px;

  a {
    margin: 0 5px;
    span {
      margin-right: 5px;
      font-size: 15px;
      vertical-align: middle;
    }
  }
  img {
    vertical-align: middle;
    display: inline;
    border: 0;
    padding: 0;
    margin: 0;
    opacity: 0.8;

    &:hover {
      opacity: 1;
    }
  }
}

.footer-bottom-item{
  max-width: max-content;
  margin-left: unset;
  margin-right: unset;
  &.copyright{
    @media (max-width: 640px) {
      margin-bottom: 14px;
      width: 100%;
    }
  }
}
.text-primary {
  color: #008552;
}

.me-2 {
  margin-right: .5rem !important;
}

.langSelector{
  position: relative;
  .langSelectorBtn{
    background: none;
    border: none;
    color: #fff;
    padding: 10px 16px;
    padding-left: 40px;
    position: relative;
    font-size: 16px;
    border: #999 1px solid;
    border-radius: 3px;
    cursor: pointer;
    transition: all .3s ease;
    &:hover{
      box-shadow: 0 0 6px rgba(0, 0, 0, .2);
      border-color: #ddd;
    }
    &:before{
      content: "";
      position: absolute;
      left: 10px; top: 0; bottom: 0;
      width: 20px;
      background-image: url(../assets/lang/id.svg);
      background-size: 20px auto;
      background-position: center;
      background-repeat: no-repeat;
    }
    &.en{
      &:before{
        background-image: url(../assets/lang/us.svg);
      }
    }
  }
  .langSelectorMenu{
    position: absolute;
    bottom: 100%; right: 0;
    background-color: #333;
    padding: 10px 0;
    border-radius: 7px;
    margin-bottom: 12px;
    box-shadow: 0 0 6px rgba(0, 0, 0, .2);
    &:before{
      content: "";
      position: absolute;
      right: 20px; bottom: -8px;
      border-top: #333 8px solid;
      border-left: transparent 8px solid;
      border-right: transparent 8px solid;
    }
    li{
      white-space: nowrap;
      list-style: none;
      padding: 8px 24px;
      position: relative;
      padding-left: 56px;
      cursor: pointer;
      transition: all .3s ease;
      &:hover{
        background-color: #2c2c2c;
      }
      &:before{
        content: "";
        position: absolute;
        left: 24px; top: 0; bottom: 0;
        width: 20px;
        background-image: url(../assets/lang/id.svg);
        background-size: 20px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &.en{
        &:before{
          background-image: url(../assets/lang/us.svg);
        }
      }
    }
  }
}

/**
 * Support
 *
 */
.helpCnt{
  position: fixed;
  right: 30px; bottom: 30px;
  z-index: 98;
  @media (max-width: 768px) {
    right: 20px; bottom: 20px;
  }
  &.offset{
    position: absolute;
    bottom: auto; top: -30px;
    @media (max-width: 768px) {
      top: -20px;
    }
  }
  .helpInfo{
    position: absolute;
    right: 70px; top: -44px;
    white-space: nowrap;
    background-color: #eee;
    border-radius: 3px;
    padding: 6px 12px;
    color: #444;
    font-size: 14px;
    z-index: 9999;
    transition: all .2s ease;
    &.closed{
      opacity: 0;
    }
  }
  .helpMenu{
    position: absolute;
    right: 0; bottom: 70px;
    background-color: #fff;
    border-radius: 5px;
    box-shadow: 2px 2px 2px rgba(0, 0, 0, .2);
    border: #eee 1px solid;
    z-index: 9999;
    padding: 10px 0;
    min-width: 200px;
    transform: scale(0);
    transform-origin: right bottom;
    transition: all .3s ease;
    &.open{
      transform: scale(1);
    }
    h4{
      padding: 6px 20px 10px;
      border-bottom: #eee 1px solid;
      margin: 0;
      font-size: 17px;
      color: #444;
    }
    li, a{
      padding: 8px 20px;
      color: #444;
      list-style: none;
      cursor: pointer;
      display: block;
      transition: all .3s ease;
      position: relative;
      padding-left: 52px;
      &:before{
        content: "";
        position: absolute;
        left: 20px; top: 0; bottom: 0;
        width: 16px;
        background-size: 16px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &.Email:before{
        background-image: url(../assets/email.png);
      }
      &.Phone{
        &:before{
          background-image: url(../assets/phone2.png);
        }
        &.wa:before{
          background-image: url(../assets/whatsapp-green.png);
          opacity: 1;
        }
      }
      &.Help.Page:before{
        background-image: url(../assets/help-page.png);
      }
      &:hover{
        background-color: #e7f5f1;
      }
    }
  }
  .helpBlock{
    position: absolute;
    right: 0; bottom: 0;
    background-color: #369d66;
    border-radius: 50% 50% 3px 50%;
    width: 60px; height: 60px;
    box-shadow: 2px 2px 6px rgba(0, 0, 0, .2);
    text-align: center;
    color: #fff;
    font-size: 46px;
    cursor: pointer;
    transition: all .3s ease;
    // transform-origin: right bottom;
    span{
      position: absolute;
      display: block;
      left: 0; right: 0; top: 0; bottom: 0;
      transition: all .3s ease;
      &.question{
        background-image: url(../assets/question2-white.png);
        background-size: 34px auto;
        background-position: center;
        background-repeat: no-repeat;
      }
      &.close{
        background-image: url(../assets/close-white.png);
        background-size: 18px auto;
        background-position: center;
        background-repeat: no-repeat;
        opacity: 0;
      }
    }
    &:hover{
      background-color: #12b55e;
      box-shadow: 2px 2px 10px rgba(0, 0, 0, .3);
      // transform: scale(1.06);
    }
    &.open{
      background-color: #115457;
      transform: rotate(180deg) !important;
      border-radius: 50%;
      span{
        &.question{
          opacity: 0;
        }
        &.close{
          opacity: 1;
        }
      }
    }
  }
}
</style>
